export default __webpack_public_path__ + "static/media/img-composition-triangles.bc7cd904.svg";